__turbopack_context__.v({
  "className": "roboto_mono_d50fc3e3-module__IwS3uG__className",
  "variable": "roboto_mono_d50fc3e3-module__IwS3uG__variable",
});
